import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {pastMeetingData} from '../../models/tableDialogModel';
import {pastData} from '../../models/tableDialogModel';
import { MatTableDataSource } from '@angular/material/table';
@Component({
  selector: 'app-table-dialog',
  templateUrl: './table-dialog.component.html',
  styleUrls: ['./table-dialog.component.css']
})
export class TableDialogComponent implements OnInit {
  meetingInfoData: any;
  agendaList : any;
  // minutesList : []
  emptyArray : any = []
  assignedToArray : any = []
  dataSource : any;
  newArray : any = []
  taskAssign :any =[];
  showContent = true ;
  readOnlyQuillConfig: any = {
    letter: false,
    modules: {
      toolbar: false
    },
    placeholder: ' ',
    theme: 'snow',
  };
  constructor(@Inject(MAT_DIALOG_DATA) data:any) { 
    this.meetingInfoData = data;
    let agendaList = this.meetingInfoData.agendaList;
    agendaList.forEach((element: any) => {
      let array = element.minutesList
      array.forEach((ele: any) => {
       let ownerNames = "";
        if(ele.entityType=="AI"){
          if(ele.isPrivate == "Y"&&ele.createdByName == localStorage.getItem('userName') || ele.isPrivate == "N"){
          this.showContent =false;
          const tempJSON = {
            "createdByName":"",
            "dueDateStr":"",
            "taskTitle":"",
            "assignedTo":"",
            "status":"",
            "agendaTitle":"",
            "agendaId":""
            
          };
          if(ele.actionItemOwner!=null){
            ele.actionItemOwner.forEach((e: any) => {
              ownerNames = ownerNames + e.ownerName+", ";
            });
          }
          tempJSON.createdByName=ele.createdByName;
          tempJSON.dueDateStr=ele.dueDateStr;
          tempJSON.taskTitle=ele.taskTitle;
          tempJSON.assignedTo=ownerNames.replace(/,\s*$/, "");
          tempJSON.status=ele.commonStatusDesc;
          tempJSON.agendaTitle = element.agendaTitle
          tempJSON.agendaId = element.agendaId
          this.taskAssign.push(tempJSON);
          
        }
      }
      });
    });
    this.dataSource = new MatTableDataSource(this.taskAssign)
  }

  // displayedColumns = ['noteDescription', 'createdByName'];
  displayedColumns = ['taskTitle', 'createdByName', 'assignedTo', 'dueDateStr', 'status'];
  // dataSource = pastData;

  ngOnInit(): void {
  }
  isTaskExist(agendaDetail:any){
    ////consolee.log('agendaId=',agendaDetail);
    var taskFound : boolean=false;
    agendaDetail.minutesList.forEach((e: any) => {
      if(e.entityType=="AI"){
        taskFound=true;
      }
    });
    //
    return taskFound;
  }
// ngAfterViewInit() {

//     // Attach paginator for each dataSource

//     this.meetingInfoData.agendaList.forEach((item: any, index: number) => {

//       const paginator = this.linkedTaskPaginators.toArray()[index];

//       if (paginator) {

//         this.dataSources[item.agendaId].paginator = paginator;

//       }

//     });

//   }
 
  // isTaskExist(agendaDetail: any) {

  //   return agendaDetail.minutesList.some((e: any) => e.entityType === "AI");

  // }
 
  // getTasksByAgendaId(agendaId: string) {

  //   return this.dataSources[agendaId] || new MatTableDataSource([]);

  // }
}
